import { ParamType } from "../../../../poly/ParamType";
export var JsConnectionPointType = /* @__PURE__ */ ((JsConnectionPointType2) => {
  JsConnectionPointType2["BOOL"] = "bool";
  JsConnectionPointType2["INT"] = "int";
  JsConnectionPointType2["FLOAT"] = "float";
  JsConnectionPointType2["VEC2"] = "vec2";
  JsConnectionPointType2["VEC3"] = "vec3";
  JsConnectionPointType2["VEC4"] = "vec4";
  return JsConnectionPointType2;
})(JsConnectionPointType || {});
export const JS_CONNECTION_POINT_TYPES = [
  "bool" /* BOOL */,
  "int" /* INT */,
  "float" /* FLOAT */,
  "vec2" /* VEC2 */,
  "vec3" /* VEC3 */,
  "vec4" /* VEC4 */
];
export const JsConnectionPointTypeToParamTypeMap = {
  ["bool" /* BOOL */]: ParamType.BOOLEAN,
  ["int" /* INT */]: ParamType.INTEGER,
  ["float" /* FLOAT */]: ParamType.FLOAT,
  ["vec2" /* VEC2 */]: ParamType.VECTOR2,
  ["vec3" /* VEC3 */]: ParamType.VECTOR3,
  ["vec4" /* VEC4 */]: ParamType.VECTOR4
};
export const JsParamTypeToConnectionPointTypeMap = {
  [ParamType.BOOLEAN]: "bool" /* BOOL */,
  [ParamType.COLOR]: "vec3" /* VEC3 */,
  [ParamType.INTEGER]: "int" /* INT */,
  [ParamType.FLOAT]: "float" /* FLOAT */,
  [ParamType.FOLDER]: void 0,
  [ParamType.VECTOR2]: "vec2" /* VEC2 */,
  [ParamType.VECTOR3]: "vec3" /* VEC3 */,
  [ParamType.VECTOR4]: "vec4" /* VEC4 */,
  [ParamType.BUTTON]: void 0,
  [ParamType.PARAM_PATH]: void 0,
  [ParamType.NODE_PATH]: void 0,
  [ParamType.RAMP]: void 0,
  [ParamType.STRING]: void 0
};
export const JsConnectionPointInitValueMap = {
  ["bool" /* BOOL */]: false,
  ["int" /* INT */]: 0,
  ["float" /* FLOAT */]: 0,
  ["vec2" /* VEC2 */]: [0, 0],
  ["vec3" /* VEC3 */]: [0, 0, 0],
  ["vec4" /* VEC4 */]: [0, 0, 0, 0]
};
export const GlConnectionPointComponentsCountMap = {
  ["bool" /* BOOL */]: 1,
  ["int" /* INT */]: 1,
  ["float" /* FLOAT */]: 1,
  ["vec2" /* VEC2 */]: 2,
  ["vec3" /* VEC3 */]: 3,
  ["vec4" /* VEC4 */]: 4
};
import { BaseConnectionPoint } from "./_Base";
export class JsConnectionPoint extends BaseConnectionPoint {
  constructor(_name, _type) {
    super(_name, _type);
    this._type = _type;
    this._init_value = JsConnectionPointInitValueMap[this._type];
  }
  type() {
    return this._type;
  }
  are_types_matched(src_type, dest_type) {
    return src_type == dest_type;
  }
  get param_type() {
    return JsConnectionPointTypeToParamTypeMap[this._type];
  }
  get init_value() {
    return this._init_value;
  }
  toJSON() {
    return this._json = this._json || this._create_json();
  }
  _create_json() {
    return {
      name: this._name,
      type: this._type
    };
  }
}
